var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V113.994H0V-0.00585938Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.594H513V341.594H0V227.594Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2 170.994L252.9 147.894C254.9 141.994 258 141.894 260 147.894L267.7 170.994L287.1 200.094C288.8 202.694 288.4 206.394 285.9 208.094C285.9 208.094 279 216.094 256.4 216.094C233.8 216.094 226.9 208.094 226.9 208.094C224.5 206.094 224 202.694 225.7 200.094L245.2 170.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 170.994C244 170.994 233.9 160.894 233.9 148.394C233.9 135.894 244 125.794 256.5 125.794C269 125.794 279.1 135.894 279.1 148.394C279.1 160.894 268.9 170.994 256.5 170.994ZM256.5 170.994C262.7 170.994 267.8 154.694 267.8 148.394C267.8 142.194 262.7 137.094 256.5 137.094C250.3 137.094 245.2 142.194 245.2 148.394C245.2 154.694 250.2 170.994 256.5 170.994Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/LS.a465448c7b87edf8ba3cd4fe23ddb3c2.svg";
export { ForwardRef as ReactComponent };